import { type ReactNode, Fragment } from 'react';

import { type LinkProps, Link } from '@playbooks/ui/components/link';

type OptionalCardLinkProps = Omit<LinkProps, 'href'> & {
	href?: LinkProps['href'];
	children: ReactNode;
};

const OptionalCardLink = ({ href, children, ...props }: OptionalCardLinkProps) => {
	if (!href) return <Fragment>{children}</Fragment>;
	return (
		<Link href={href} {...props}>
			{children}
		</Link>
	);
};

export { OptionalCardLink };
export type { OptionalCardLinkProps };
